import React from 'react';
import { Form } from 'react-bootstrap';
import { FormRadio } from '~/components/FormControl';

function MiscellaneousDetail() {
    return (
        <Form.Row>
            <FormRadio
                name="miscellaneousDetail.hasDamage"
                tooltip="To state that the card deals damage."
            />
            <FormRadio
                name="miscellaneousDetail.hasBlock"
                tooltip="To state that the card blocks damage."
            />
            <FormRadio
                name="miscellaneousDetail.hasEvade"
                tooltip="To state that the card evades."
            />
            <FormRadio
                name="miscellaneousDetail.isTransformable"
                tooltip="To state that the card is transformable."
            />
            <FormRadio
                name="miscellaneousDetail.isBlockIgnored"
                tooltip="To state that the card ignores block."
            />
            <FormRadio
                name="miscellaneousDetail.isInnate"
                tooltip="To label this card if it is an Innate by default."
            />
        </Form.Row>
    );
}

export default MiscellaneousDetail;
